interface OfflineBannerProps {
  isOnline: boolean;
  pendingCount: number;
}

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
   document.documentElement.classList.contains('reduced-motion'));

export default function OfflineBanner({ isOnline, pendingCount }: OfflineBannerProps) {
  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 900,
        background: 'linear-gradient(135deg, var(--color-warning-fg) 0%, var(--color-warning-border) 100%)',
        color: 'var(--color-warning-bg)',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        fontSize: 'var(--fs-sm)',
        fontWeight: 600,
        animation: prefersReducedMotion() ? 'none' : 'cwOfflineBannerSlide 0.35s ease-out',
        boxShadow: 'var(--shadow-raised)',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 'var(--fs-base)' }}>&#x2601;&#xfe0f;</span>
      <span>
        You're offline &mdash; your data is safe
        {pendingCount > 0 && (
          <span style={{ fontWeight: 400, fontSize: 'var(--fs-xs)', marginLeft: 8, opacity: 0.85 }}>
            ({pendingCount} item{pendingCount > 1 ? 's' : ''} waiting to sync)
          </span>
        )}
      </span>
      <style>{`
        @keyframes cwOfflineBannerSlide {
          from { transform: translateY(-100%); opacity: 0; }
          to   { transform: translateY(0);     opacity: 1; }
        }
        @media (prefers-reduced-motion: reduce) {
          [role="status"] { animation: none !important; }
        }
      `}</style>
    </div>
  );
}
